import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledCTA = styled.div`
  max-width: ${themeGet('row.rowLarge')};
  margin: ${themeGet('scale.scaleUp09')} auto;
  padding: 0 ${themeGet('scale.scaleDown03')};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    padding: 0 ${themeGet('scale.scaleUp05')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin: ${themeGet('scale.scaleUp12')} auto;
  }
`;

export default StyledCTA;